import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { FeeRateCreateDrawer } from '../../../../../../../../../../features/fees/fee-rate/fee-rate-create-drawer';
import { FeeRatesTable } from '../../../../../../../../../../features/fees/fee-rate/fee-rates-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/middle-money/fee-rate/_fee-rate/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinanceMiddleMoney,
      label: 'Fee Rates',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceMiddleMoney>,
  head: () => getPageHead('Fee Rates'),
  component: FeeRatesList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <FeeRateCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Fee Rate" size="small" />} />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingFinanceMiddleMoney}
    />
  );
}

function FeeRatesList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FeeRatesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
